import { signInWithPasskey, supported } from '../webauthn/passkeys';

document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('#webauthn-sign-in');

  if (!button || !supported()) return;

  button.classList.remove('d-none');

  button.addEventListener('click', event => {
    event.preventDefault();

    button.disabled = true;
    const sessionUrl = button.dataset.sessionUrl;
    const optionsUrl = button.dataset.optionsUrl;

    const errorBox = document.querySelector('#webauthn-error');
    // remove errorBox from document
    if (errorBox) errorBox.remove();

    signInWithPasskey({
      optionsUrl,
      sessionUrl
    })
      .then(data => {
        globalThis.location = data.redirect_to || '/';
      })
      .catch(error => {
        // find the form with ID 'new_user' and display the error message in a
        // div with ID 'webauthn-error'
        const form = document.querySelector('#new_user');
        if (form) {
          if (errorBox) {
            errorBox.textContent = error.message;
          } else {
            // if the error box doesn't exist, create it and append it to the form
            const newErrorBox = document.createElement('div');
            newErrorBox.id = 'webauthn-error';
            newErrorBox.className = 'alert alert-warning';
            newErrorBox.textContent = error.message;
            // add it to the top of the form
            form.insertBefore(newErrorBox, form.firstChild);
          }
        }

        button.disabled = false;
      });
  });
});
